export default "__VITE_ASSET__CeOZK5Id__"